import { render, staticRenderFns } from "./ServicesCliente.vue?vue&type=template&id=edc8b092&"
import script from "./ServicesCliente.vue?vue&type=script&lang=js&"
export * from "./ServicesCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports